import useApi, { ApiOptions } from '../base/useApi';

interface Params {
  inventoryId: string;
  migrateId?: string;
}

interface Result {}

const options: ApiOptions = {
  method: 'delete',
  urlPath: '/inventory/',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useDeleteInventoryLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useDeleteInventoryLazy;
